<template>
  <div class="card">
    <div class="card-header">
      <div>
        <span
          v-for="lieu in lieux"
          :key="lieu"
          class="badge"
        >
          {{ lieu }}
        </span>
      </div>
      <img v-if="image" :src="imageSrc" alt="Image de l'association" class="asso-image" />
      <h4>{{ nom }}</h4>
    </div>

    <div class="card-content">
      <h4>{{ description }}</h4>
    </div>

    <div class="card-footer">
      <slot name="footer">
        <button @click="$emit('delete')">Supprimer</button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeleteAssociationComponent',
  props: {
    nom: String,
    description: String,
    lieux: Array,
    image: String
  },
  computed: {
    imageSrc() {
      if (this.image?.startsWith('data:image')) return this.image;
      return `data:image/png;base64,${this.image}`;
    }
  }
}
</script>

<style>
.card {
  border-radius: 12px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  height: 370px; /* Hauteur uniforme pour toute la carte */
  width: 300px; /* Largeur uniforme pour toutes les cartes */
  box-sizing: border-box;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  overflow: hidden;
  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Animation douce */
}

.card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  transform: translateY(-5px);
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #1E1C66;
  margin-bottom: 10px;
  height: 170px;
  justify-content: flex-start;
}

.card-header h4 {
  color: black;
  font-size: 1.2rem;
  margin-top: 10px;
  margin-bottom: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}


.card-content {
  flex: 1;
  margin: 10px 0;
  text-align:center;
  color: #1E1C66;
  font-size: 0.9rem;
  max-height: 80px; /* Hauteur maximale pour la description */
  overflow-y: auto; /* Défilement vertical si nécessaire */
}

.card-footer {
  margin-top:20px;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.card-footer > button {
  flex: 1;
  background-color: rgb(184, 4, 4);
  color: white;
  border-radius: 6px;
  border: none;
  padding: 0.5rem;
  font-weight: bold;
  transition: background-color 0.2s;
  cursor: pointer;
}

.card-footer > button:hover {
  background-color: #B67F33;
}

.badge {
  display: inline-block;
  background-color: #167580;
  color: white;
  border-radius: 6px;
  padding: 2px 8px;
  margin-right: 4px;
  font-size: 0.8em;
  margin-bottom: 5px;
}

.asso-image {
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn-delete {
  flex: 1;
  background-color: #B82828;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-delete:hover {
  background-color: #9e1f1f;
}

.btn-edit {
  flex: 1;
  background-color: #1E1C66;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-edit:hover {
  background-color: #393776;
}
</style>
